import { APIMethods, apiProxy, Message, TResponse } from 'utils/api/apiRequestProxy';
import { TCreateUserFeedback } from './types';

export const userFeedbackQueryKey = 'userFeedback';

export async function createUserFeedback(payload: TCreateUserFeedback): Promise<TResponse<Message>> {
    return apiProxy<Message>({
        url: '/user_feedbacks/',
        method: APIMethods.POST,
        data: payload,
    });
}
